import { useBoxStyle } from "arkh";
import React from "react";
import { WTCSSelectRoutines } from "./WTCSSelectRoutine";
import { WTCSSelectTasks } from "./WTCSSelectTasks";
import { WTCSMain } from "./WTCSMain";
import { WTCSStack } from "./WTCSStack";
import { useIntlTokens } from "../../../../../../components/mobile/useIntlTokens";
import { WTCSSelectTeams } from "./WTCSSelectTeam";
import { useNavigationHeaderOptions } from "@/src/common/navigationHeaderOptions";

export function WidgetTaskCollectionSettingsNavigator(props: {
  storecastId: string;
  onCancel(): void;
}) {
  const contentStyle = useBoxStyle({ color: "surface-background-light" });
  const intl_tokens = useIntlTokens();
  const getHeaderOptions = useNavigationHeaderOptions();
  return (
    <WTCSStack.Navigator
      screenOptions={{
        contentStyle,
      }}
    >
      <WTCSStack.Screen
        name="WTCSMain"
        component={WTCSMain}
        initialParams={{
          storecastId: props.storecastId,
        }}
        options={getHeaderOptions({
          type: "CANCEL",
          onClose: props.onCancel,
          title: intl_tokens.Tasks,
          defaultContentStyle: true,
        })}
      />
      <WTCSStack.Screen
        name="WTCSSelectTeams"
        component={WTCSSelectTeams}
        options={({ navigation }) =>
          getHeaderOptions({
            title: intl_tokens.Teams,
            type: "BACK",
            onBack: () => {
              navigation.goBack();
            },
            defaultContentStyle: true,
          })
        }
      />
      <WTCSStack.Screen
        name="WTCSSelectRoutine"
        component={WTCSSelectRoutines}
        options={({ navigation }) =>
          getHeaderOptions({
            title: intl_tokens.AddTasks,
            type: "BACK",
            onBack: () => {
              navigation.goBack();
            },
            defaultContentStyle: true,
          })
        }
      />
      <WTCSStack.Screen
        name="WTCSSelectTasks"
        component={WTCSSelectTasks}
        options={({ navigation }) =>
          getHeaderOptions({
            type: "DONE",
            onDone: () => {
              navigation.pop(2);
            },
            title: intl_tokens.AddTasks,
            defaultContentStyle: true,
          })
        }
      />
    </WTCSStack.Navigator>
  );
}
